import PropTypes from "prop-types";
import React from "react";
import BenefitEnrolment from "./BenefitEnrolment";

const EnrolmentInfo = ({ data, isEnrolmentEnabled }) => {
  if (!data) {
    return null;
  }
  const { status } = data;
  return (
    status !== "Ended" &&
    isEnrolmentEnabled && <BenefitEnrolment key={"BenefitEnrolment"} enrolmentInfo={data} />
  );
};

EnrolmentInfo.propTypes = {
  data: PropTypes.shape({
    periodEnd: PropTypes.string,
    periodStart: PropTypes.string,
    status: PropTypes.string.isRequired,
  }),
};

export default EnrolmentInfo;



// WEBPACK FOOTER //
// ./components/dashboard/widgets/EnrolmentInfo.js